export enum EntrepriseTypeEnum {
  ENTERPRISE = 'Entreprise',
  WORK_COUNCIL = 'Comité Social Economique',
  ASSOCIATION = 'Association',
  PUBLIC_SECTOR = 'Secteur Public'
}
